import { render, staticRenderFns } from "./yearOrMonthkWh2.vue?vue&type=template&id=5780a479&scoped=true&"
import script from "./yearOrMonthkWh2.vue?vue&type=script&lang=js&"
export * from "./yearOrMonthkWh2.vue?vue&type=script&lang=js&"
import style0 from "./yearOrMonthkWh2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yearOrMonthkWh2.vue?vue&type=style&index=1&id=5780a479&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780a479",
  null
  
)

export default component.exports